import React from 'react'
import './style.css'
import 'font-awesome/css/font-awesome.min.css'
import { Container, Button } from 'react-bootstrap'
import { Link } from 'gatsby'
import WebriQForm from '@webriq/gatsby-webriq-form'

const Header = () => (
  <div id="footer">
    <section id="touch">
      <Container>
        <div className="row">
          <div className="col-sm-4 mb-5">
            <div className="left-content">
              <div id="explore">
                <span className="touch-head">
                  <h6 className="custom-underline text-uppercase mb-4">
                    Explore
                  </h6>
                </span>
                <Link className="links-touch" to="/8a-sole-source-advantages">
                  8A Sole source advantages
                </Link>
                <Link className="links-touch" to="/our-services">
                  OUR SERVICES
                </Link>
                <Link className="links-touch" to="/news">
                  PERIN INSIGHTS
                </Link>
                <Link className="links-touch" to="/data-encryption">
                  DATA ENCRYPTION
                </Link>
                <Link className="links-touch" to="/privacy-policy">
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
          <div className="col-sm-4 mb-5">
            <div className="center-content">
              <div id="contact-us">
                <span className="touch-head">
                  <h6 className="custom-underline text-uppercase mb-4">
                    Contact Us
                  </h6>
                </span>
                <a
                  className="links-touch"
                  href="tel:833-234-6348"
                  title="Find It"
                >
                  833-234-6348
                </a>
                {/*             <a
                className="links-touch"
                href="mailto:info@PerinInvestigations.com"
                title="Mail"
              >
                info@PerinInvestigations.com
              </a>*/}
                <p className="mt-4 text-white">Colorado</p>
                <a
                  className="links-touch"
                  id="links-touch-address"
                  href="https://www.google.com/maps/place/1888+Sherman+St+Suite+370,+Denver,+CO+80203,+USA/@39.7459124,-104.9843852,17z/data=!3m1!4b1!4m6!3m5!1s0x876c7929cbb00001:0xeb2c5ed5a9b03b0!8m2!3d39.7459124!4d-104.9843852!16s%2Fg%2F11mbqssh_1?entry=ttu"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Address Map"
                >
                  1888 N. Sherman Street <br />
                  Suite 370 <br />
                  Denver, CO 80203
                </a>
                <p className="mt-3 text-white">California</p>
                <a
                  className="links-touch"
                  id="links-touch-address"
                  href="https://www.google.com/maps?ll=34.260857,-119.229387&z=17&t=m&hl=en&gl=PH&mapclient=embed&q=1300+Eastman+Ave+%23102+Ventura,+CA+93003+USA"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Address Map"
                >
                  1300 Eastman Ave.
                  <br />
                  Suite 102
                  <br />
                  Ventura, CA 93003
                </a>
                <div className="social-footer">
                  <a
                    href="https://www.facebook.com/end2endEDiscovery"
                    title="Facebook"
                    className="social-footer-links"
                    id="facebook-icon"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>Facebook</span>
                  </a>
                  <a
                    href="https://www.linkedin.com/in/perin-discovery-6aaa98161/"
                    title="Linkedin"
                    className="social-footer-links"
                    id="linkedin-icon"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>Linkedin</span>
                  </a>
                  <a
                    href="https://twitter.com/PerinDiscovery"
                    title="Twitter"
                    className="social-footer-links"
                    id="twitter-icon"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>Twitter</span>
                  </a>

                  {/* remove the google icon */}
                  {/* <a
                    href="https://g.page/r/CQ0MwGBiQXW8EBA?we"
                    title="Linkedin"
                    className="social-footer-links"
                    id="google-icon"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>Email</span>
                  </a> */}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 mb-2 ">
            <div className="right-content">
              <div id="perin-insight">
                <span className="touch-head">
                  <h6 className="custom-underline text-uppercase mb-4">
                    Opt in to Perin's Insight
                  </h6>
                </span>
                <WebriQForm
                  id="online-appointment-form"
                  name="Newsletter Form"
                  className="newsletter"
                  data-form-id="5d39408e3082f15cfb2a1988"
                  data-thankyou-url="/thank-you"
                >
                  <p className="text-white links-touch">Enter Your Email</p>
                  <div className="form-group">
                    <input
                      className="form-control footer-input"
                      type="text"
                      name="email"
                      id="name"
                    />
                  </div>
                  <div className="form-group">
                    <div className="webriq-recaptcha"></div>
                  </div>
                  <Button className="btn-secondary" type="submit">
                    SUBSCRIBE
                  </Button>
                </WebriQForm>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
    <section id="copyright">
      <div className="container">
        <div className="d-blockt text-center text-md-left d-md-flex justify-content-between align-items-center">
          <p className="copyright mb-0 text-white">
            © {new Date().getFullYear()} Perin Discovery LLC. All Rights
            Reserved.
          </p>
          <p className="copyright mb-0 text-white">
            Designed and Powered by 
            <a
              href="https://www.webriq.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span style={{ color: '#35ADAF' }}>WebriQ</span>
            </a>
            <span>.</span>
          </p>
        </div>
      </div>
    </section>
  </div>
)

export default Header
